// libs
import React from 'react';
import PropTypes from 'prop-types';

// Component
import Card from '../../../../cards/card/Card';

// styles
import './styles.scss';

// proptypes & context
const propTypes = {
  content: PropTypes.object.isRequired,
};

const defaultProps = {};

const contextTypes = {
  t: PropTypes.func,
};


function Slide(props) {
  const {
    content: {
      diapo_title: title,
      link,
      background_image: backgroundImage,
      front_content: frontContent,
    },
  } = props;
  return (
    <div className="slide">
      <div className="slide__content">
        {title &&
          <h2 className="slide__title">{title}</h2>
        }
        {link && link.link && link.link_title &&
        <a className="slide__link link link--arrow" href={link.link}>{link.link_title}</a>
        }
      </div>
      <div className="slide__images">
        {backgroundImage &&
        <picture className="slide__images__background">
          <img
            src={backgroundImage.sizes.large}
            alt={backgroundImage.alt}
            title={backgroundImage.title}
          />
        </picture>
        }
        <div className="slide__card">
          <Card {...frontContent[0]} />
        </div>
      </div>
    </div>
  );
}

Slide.propTypes = propTypes;
Slide.defaultProps = defaultProps;
Slide.contextTypes = contextTypes;

export default Slide;



// WEBPACK FOOTER //
// ./src/app/components/pages/home/parts/slide/Slide.js